import {
  Box,
  Card,
  CardContent,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import GoogleAddressAutocomplete from "../GoogleAddressAutocomplete";
import { LoadingButton } from "@mui/lab";

import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getCountyAndCity } from "../../../store/actions/dataActions";

const QuickActionPermit = () => {
  const [address, setAddress] = useState("");
  const [validateAddressLoading, setValidateAddressLoading] = useState(false);
  const [invalidAddressText, setInvalidAddressText] = useState("");
  const [inputValue, setInputValue] = useState("");

  const handleValidateAddress = async () => {
    try {
      const invalidText =
        "Please enter a valid address with a house number and street name.";
      if (address.trim()) {
        setValidateAddressLoading(true);
        const trimmed = address.trim();

        if (!isValidAddress(trimmed) || !address) {
          setInvalidAddressText(invalidText);
          return;
        }
        const result = await dispatch(getCountyAndCity(address));

        if (!result?.success) {
          setInvalidAddressText(result?.error);
          return;
        } else {
          navigate("/permits/create");
        }
      } else {
        setInvalidAddressText(invalidText);
      }
    } catch (e) {
    } finally {
      setValidateAddressLoading(false);
      setTimeout(() => {
        setInvalidAddressText("");
      }, 5000);
    }
  };

  const isValidAddress = (input) => {
    const trimmed = input.trim();
    return /\d+/.test(trimmed) && /[a-zA-Z]{3,}/.test(trimmed);
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <Card
      sx={{
        boxShadow: "2px 6px 12px rgba(0, 0, 0, 0.5) !important",
      }}
    >
      <CardContent
        sx={{
          pt: 0,
          minHeight: "15rem",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <Typography
            variant="h6"
            textAlign="center"
            gutterBottom
            mb={2}
            mt={2}
          >
            Create Permit
          </Typography>
          <GoogleAddressAutocomplete
            label="Property Address"
            onSelect={(val) => setAddress(val)}
            address={address}
            inputValue={inputValue}
            setInputValue={setInputValue}
          />
          <Box sx={{ my: 1, minHeight: "2rem" }}>
            <Typography color="error" variant="body2" textAlign="center">
              {invalidAddressText}
            </Typography>
          </Box>
        </Box>

        <Box textAlign="center" gap={1} sx={{ display: "flex" }}>
          <LoadingButton
            loading={validateAddressLoading}
            fullWidth
            variant="contained"
            color="primary"
            onClick={handleValidateAddress}
            endIcon={<AddIcon />}
          >
            Create
          </LoadingButton>
          <Tooltip title="Clear Address">
            <span>
              <IconButton
                onClick={() => {
                  setAddress("");
                  setInputValue("");
                }}
                disabled={address === "" || validateAddressLoading}
                sx={{
                  color: "error.main",
                  "&:hover": {
                    backgroundColor: "rgba(255, 0, 0, 0.1)",
                  },
                }}
              >
                <DeleteIcon />
              </IconButton>
            </span>
          </Tooltip>
        </Box>
      </CardContent>
    </Card>
  );
};

export default QuickActionPermit;
